import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BaseComponent } from '@hub/common/BaseComponent';
import { MenuService } from '@hub/components/v1/header';
import { InteractionStatus } from "@azure/msal-browser";
import { MsalBroadcastService } from "@azure/msal-angular";
import { AuthService } from '@hub/services/AuthService';
import { filter, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
	templateUrl: 'layout.component.html',
	styleUrls: ['./layout.component.css']
})
export class LayoutComponent extends BaseComponent implements OnInit, OnDestroy {

	constructor(
    private zone: NgZone,
		private router: Router,
		private menuService: MenuService,
		public authService: AuthService,
		private msalBroadcastService: MsalBroadcastService,
	) {
		super();
	}

	IsOpened: Boolean = false;
	sub: Subscription = new Subscription();

	ngOnInit(): void {
		this.sub.add(this.msalBroadcastService.inProgress$
			.pipe(
				filter((status: InteractionStatus) => status === InteractionStatus.None),
				take(1)
			)
			.subscribe(() => {
				this.sub.add(this.menuService.change.subscribe(isVisible => {
					this.zone.run(() => {
						this.IsOpened = isVisible;
					});
				}));

				this.sub.add(this.router.events
					.pipe(filter(i => i instanceof NavigationStart))
					.subscribe((value: NavigationStart) => {
						if (value.url.indexOf('login') === -1 && !this.authService.isLogged) {
							this.authService.redirectUrl = value.url;
							this.router.navigate(['/login']);
						}
					}));
			}));
  	}

	ngOnDestroy() {
		this.sub.unsubscribe();
	}
}
